export const SHIPMENT_PROBLEMS_UNEXPECTED_SKU_BLADE_ID = "inbounds.shipmentProblemUnexpectedSkuBlade";
export const SHIPMENT_PROBLEMS_MISMATCH_CASE_QTY_BLADE_ID = "inbounds.shipmentProblemMismatchCaseQtyBlade";
